import { Controller } from "@hotwired/stimulus"

// The row answers the button before the server does, so acknowledging a mention
// costs no round trip and no re-render. Both verbs ship as their own form, so
// nothing has to rewrite a request on its way out. A failed request flips back.
export default class extends Controller {
  static targets = ["markRead", "markUnread"]
  static classes = ["read"]
  static values = { read: Boolean }

  toggle() {
    const held = this.element.contains(document.activeElement)
    const read = (this.readValue = !this.readValue)

    this.element.classList.toggle(this.readClass, read)
    this.markReadTarget.hidden = read
    this.markUnreadTarget.hidden = !read

    if (held) this.#offered.focus()
  }

  restore({ detail: { success } }) {
    if (!success) this.toggle()
  }

  // Hiding the pressed button drops focus, so hand it to the one that replaced it.
  get #offered() {
    return (this.readValue ? this.markUnreadTarget : this.markReadTarget).querySelector("button")
  }
}
